/**
 * Simple event emitter wrapper around the browser's CustomEvent API.
 * Write code like it's 2010 but don't have to worry about shims, polyfills,
 * nor transpiling because DHH said so.
 */

type EventDetail = Record<string, any>;

export type EventListenerCallback = (event: CustomEvent<EventDetail>) => void;

const emitEvent = (eventName: string, detail: EventDetail): void => {
  const event = new CustomEvent(eventName, { detail });
  window.dispatchEvent(event);
};

const addEventListener = (
  eventName: string,
  callback: EventListenerCallback,
): void => {
  window.addEventListener(eventName, callback as EventListener);
};

const removeEventListener = (
  eventName: string,
  callback: EventListenerCallback,
): void => {
  window.removeEventListener(eventName, callback as EventListener);
};

export { emitEvent, addEventListener, removeEventListener };
